import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_CHEST_02: ReviewedLibraryIdentity[] = [
  {
    "id": "library-fanjue-incline-machine-chest-press",
    "name": "上斜器械推胸",
    "group": "chest",
    "subCategory": "upper-chest",
    "equipment": "machine",
    "pattern": "上斜固定器械推",
    "legacyIds": [
      "fanjue-incline-machine-chest-press"
    ],
    "sourceId": "course-20261008-four-way-01-04",
    "targetMuscles": [
      "胸大肌上部",
      "三角肌前束",
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
